<div class="my-body">
    <div class="cards" *ngIf="hasInfo()">
      <div *ngFor="let pak of getPackagesByType()">
        
        <div [class]="getCssClass(pak)" *ngIf="pak.name">
          <ul>
            <li class="pack">{{pak.name}}</li>
            <!-- <li class="pack" *ngIf="!pak.name">No hay información</li> -->
            <h2 class="price-box__discount" >
              <span class="price-box__dollar" *ngIf="pak.price">$</span>{{pak.price}}<span class="price-box__discount--light"></span>
            </h2>
            <h3 class="price-box__price">
              ${{getOldPrice(pak.price)}}
            </h3>
            <p *ngIf="pak.name != 'Basic'" style="font-size: 10px">* incluye los servcios del paquete anterior</p>
          </ul>
          <ul>
            <li *ngFor="let pro of pak.products" class="bottom-bar" >
              {{pro}}
            </li>
          </ul>
          <ul>
            <!-- <li *ngIf="!isPackChosen(pak)">
              <button class="btn" (click)="bookNow(pak)">
                Me interesa
              </button>
            </li> -->
            <li class="paid" *ngIf="isPackChosen(pak)">Contratado<i class="fas fa-check my-icon" style="color: #FFFFFF;"></i></li>
          </ul>
        </div>
        
      </div>
    </div>

    <div class="center" style="margin: 3rem auto;">
      <mat-spinner *ngIf="packages && packages.length ==0" diameter="65"></mat-spinner>
    </div>

    
  </div>
  

  <!-- <app-carton-dance *ngIf="!packages"></app-carton-dance> -->
  
  <div class="parallax" *ngIf="false">
    <!-- carousel: midground parallax layer -->
    <div class="carousel" id="carousel">
      <mat-card *ngFor="let card of cards" class="carousel-cell"><!-- getPackagesByType() -->
        <span>DEV</span>
      </mat-card>
    </div>
  </div>